import { render, staticRenderFns } from "./GdprNotice.vue?vue&type=template&id=dc980fa6"
import script from "./GdprNotice.vue?vue&type=script&lang=js"
export * from "./GdprNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports